import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Card, Table, Alert } from 'react-bootstrap';
import axios from '../../axios/axiosconf';
import ModalDatosFacturacion from '../rips/ModalDatosFacturacion';

function CompletarDatosFactura({ show, facturaId, onComplete, onCancel }) {
    const [factura, setFactura] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    // Estados para el flujo de modales
    const [showModalDatosFacturacion, setShowModalDatosFacturacion] = useState(false);
    const [showModalEnvioDian, setShowModalEnvioDian] = useState(false);
    const [showModalEnviando, setShowModalEnviando] = useState(false);
    const [mensajeEnvio, setMensajeEnvio] = useState('');
    const [errorEnvio, setErrorEnvio] = useState(null);
    
    const [datosRips, setDatosRips] = useState(null);

    useEffect(() => {
        if (show && facturaId) {
            cargarFactura();
        }
    }, [show, facturaId]);

    const cargarFactura = async () => {
        try {
            setLoading(true);
            setError(null);
            
            let userdata = JSON.parse(localStorage.getItem('userdata'));
            const response = await axios.get(`/factura/${facturaId}?uid=${userdata.user_id}`);
            
            if (response.status === 200) {
                setFactura(response.data);
                
                // Preparar datos para el modal de facturación
                // Extraer valores de los items de la factura
                const items = response.data.items || [];
                const itemConsulta = items.find(i => i.tipo === 'consulta');
                const itemProcedimiento = items.find(i => i.tipo === 'procedimiento');
                
                setDatosRips({
                    tipo_consulta: itemConsulta ? true : false,
                    cupsc: itemConsulta?.cups_code || '',
                    valorconsulta: itemConsulta?.valor || '0',
                    descuento_consulta: itemConsulta?.descuento || '0',
                    impuesto_consulta: itemConsulta?.impuesto || '0',
                    total_consulta: itemConsulta?.total || '0',
                    
                    tipo_procedimiento: itemProcedimiento ? true : false,
                    cupsp: itemProcedimiento?.cups_code || '',
                    valorprocedimiento: itemProcedimiento?.valor || '0',
                    descuento_procedimiento: itemProcedimiento?.descuento || '0',
                    impuesto_procedimiento: itemProcedimiento?.impuesto || '0',
                    total_procedimiento: itemProcedimiento?.total || '0',
                    
                    total_bruto: response.data.valor_bruto || '0',
                    total_pagar: response.data.valor_total || '0'
                });
                
                // Abrir directamente el modal de datos de facturación
                setShowModalDatosFacturacion(true);
            }
        } catch (err) {
            console.error('Error cargando factura:', err);
            setError('Error al cargar los datos de la factura');
        } finally {
            setLoading(false);
        }
    };

    const handleConfirmarDatosFacturacion = async (datosCompletos) => {
        try {
            setShowModalDatosFacturacion(false);
            
            let userdata = JSON.parse(localStorage.getItem('userdata'));
            
            // Preparar datos para actualizar la factura
            const datosActualizacion = {
                prefijo: datosCompletos.prefijo,
                metodo_pago: datosCompletos.metodo_pago,
                forma_pago: datosCompletos.forma_pago,
                // Valores de transacción actualizados
                valor_bruto: parseFloat(datosCompletos.total_bruto),
                valor_total: parseFloat(datosCompletos.total_pagar),
                // Actualizar items con nuevos valores
                items: []
            };
            
            // Agregar items actualizados
            if (datosRips.tipo_consulta) {
                datosActualizacion.items.push({
                    cups_code: datosRips.cupsc,
                    tipo: 'consulta',
                    valor: parseFloat(datosCompletos.valorconsulta),
                    descuento: parseFloat(datosCompletos.descuento_consulta),
                    impuesto: parseFloat(datosCompletos.impuesto_consulta),
                    total: parseFloat(datosCompletos.total_consulta)
                });
            }
            
            if (datosRips.tipo_procedimiento) {
                datosActualizacion.items.push({
                    cups_code: datosRips.cupsp,
                    tipo: 'procedimiento',
                    valor: parseFloat(datosCompletos.valorprocedimiento),
                    descuento: parseFloat(datosCompletos.descuento_procedimiento),
                    impuesto: parseFloat(datosCompletos.impuesto_procedimiento),
                    total: parseFloat(datosCompletos.total_procedimiento)
                });
            }
            
            // Actualizar la factura (cambiar de estado 7 a estado 0)
            const response = await axios.put(
                `/facturas/${facturaId}/completar-datos?uid=${userdata.user_id}`,
                datosActualizacion
            );
            
            if (response.status === 200) {
                // Mostrar modal de confirmación de envío a DIAN
                setShowModalEnvioDian(true);
            }
        } catch (err) {
            console.error('Error completando datos:', err);
            setError(err.response?.data?.message || 'Error al completar los datos de facturación');
            setShowModalDatosFacturacion(true); // Volver a mostrar el modal para corregir
        }
    };
    
    const handleConfirmarEnvioDian = async () => {
        setShowModalEnvioDian(false);
        setShowModalEnviando(true);
        setMensajeEnvio('Enviando factura a la DIAN...');
        setErrorEnvio(null);
        
        try {
            let userdata = JSON.parse(localStorage.getItem('userdata'));
            const response = await axios.post(`/factura/${facturaId}/enviar-dian?uid=${userdata.user_id}`, {});
            
            if (response.data.success) {
                setMensajeEnvio(`✅ Factura enviada exitosamente a la DIAN\n\nCUFE: ${response.data.uuid || 'N/A'}`);
                setErrorEnvio(null);
            } else {
                setMensajeEnvio('Error al enviar a la DIAN');
                setErrorEnvio({
                    message: response.data.message || 'Error desconocido',
                    response: response.data.response,
                    json_enviado: response.data.json_enviado,
                    status_code: response.data.status_code
                });
            }
        } catch (envioError) {
            console.error('Error enviando a DIAN:', envioError);
            setMensajeEnvio('Error al enviar a la DIAN');
            setErrorEnvio({
                message: envioError.response?.data?.message || envioError.message,
                status: envioError.response?.status,
                statusText: envioError.response?.statusText,
                data: envioError.response?.data,
                fullError: envioError.response || envioError
            });
        }
    };
    
    const handleCancelarEnvioDian = () => {
        setShowModalEnvioDian(false);
        // Cerrar todo y notificar éxito (factura completada pero no enviada)
        onComplete();
    };
    
    const handleCerrarModalEnviando = () => {
        setShowModalEnviando(false);
        // Cerrar todo y notificar éxito
        onComplete();
    };

    const formatearValor = (valor) => {
        return '$' + Math.round(parseFloat(valor || 0)).toLocaleString('es-CO');
    };

    if (loading) {
        return (
            <Modal show={show} onHide={onCancel} size="lg" centered>
                <Modal.Body className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Cargando...</span>
                    </div>
                    <p className="mt-3">Cargando datos de la factura...</p>
                </Modal.Body>
            </Modal>
        );
    }

    return (
        <>
            {/* Modal de Datos de Facturación */}
            {factura && datosRips && (
                <ModalDatosFacturacion
                    show={showModalDatosFacturacion}
                    onClose={() => {
                        setShowModalDatosFacturacion(false);
                        onCancel();
                    }}
                    onConfirm={handleConfirmarDatosFacturacion}
                    profesionalId={factura.users_id}
                    datosRips={datosRips}
                />
            )}
            
            {/* Modal de Confirmación de Envío a DIAN */}
            <Modal show={showModalEnvioDian} onHide={handleCancelarEnvioDian} centered>
                <Modal.Header style={{ backgroundColor: '#28a745', color: 'white' }}>
                    <Modal.Title>
                        <i className="fas fa-check-circle mr-2"></i>
                        Factura Completada
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center py-4">
                    <div className="mb-3">
                        <i className="fas fa-file-invoice" style={{ fontSize: '64px', color: '#28a745' }}></i>
                    </div>
                    <h5 className="mb-3">¡Datos de facturación completados exitosamente!</h5>
                    <Alert variant="info" className="text-left">
                        <strong>Factura ID:</strong> {facturaId}<br />
                        <strong>Estado:</strong> Generada (lista para enviar a DIAN)
                    </Alert>
                    <p className="mb-0">¿Desea enviar esta factura a la DIAN ahora?</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCancelarEnvioDian}>
                        <i className="fas fa-clock mr-1"></i>
                        No, enviar después
                    </Button>
                    <Button variant="success" onClick={handleConfirmarEnvioDian}>
                        <i className="fas fa-paper-plane mr-1"></i>
                        Sí, enviar ahora
                    </Button>
                </Modal.Footer>
            </Modal>
            
            {/* Modal de Envío en Progreso / Resultado */}
            <Modal 
                show={showModalEnviando} 
                onHide={handleCerrarModalEnviando} 
                centered
                backdrop="static"
            >
                <Modal.Header 
                    style={{ 
                        backgroundColor: mensajeEnvio.includes('Enviando') && !errorEnvio ? '#007bff' : 
                                       errorEnvio ? '#dc3545' : '#28a745',
                        color: 'white' 
                    }}
                >
                    <Modal.Title>
                        {mensajeEnvio.includes('Enviando') && !errorEnvio ? 'Enviando a la DIAN' :
                         errorEnvio ? 'Error al Enviar a la DIAN' : 'Enviado Exitosamente'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center py-4">
                    {/* Icono dinámico según el estado */}
                    {mensajeEnvio.includes('Enviando') && !errorEnvio ? (
                        <div className="spinner-border text-primary mb-3" style={{ width: '3rem', height: '3rem' }} role="status">
                            <span className="sr-only">Enviando...</span>
                        </div>
                    ) : errorEnvio ? (
                        <i className="fas fa-times-circle text-danger mb-3" style={{ fontSize: '64px' }}></i>
                    ) : (
                        <i className="fas fa-check-circle text-success mb-3" style={{ fontSize: '64px' }}></i>
                    )}
                    
                    <h5 className="mb-3">{mensajeEnvio}</h5>
                    
                    {errorEnvio && (
                        <div className="text-left">
                            <Alert variant="danger">
                                <strong>Detalles del error:</strong>
                                <pre style={{ 
                                    maxHeight: '300px', 
                                    overflow: 'auto', 
                                    backgroundColor: '#f8f9fa',
                                    padding: '10px',
                                    borderRadius: '4px',
                                    fontSize: '12px'
                                }}>
                                    {JSON.stringify(errorEnvio, null, 2)}
                                </pre>
                            </Alert>
                            <Alert variant="info">
                                <strong>Sugerencias:</strong>
                                <ul className="mb-0 mt-2">
                                    <li>Verifique que los parámetros de facturación electrónica estén configurados correctamente</li>
                                    <li>Revise que el prefijo seleccionado esté habilitado</li>
                                    <li>Verifique la conexión con el servidor de la DIAN</li>
                                    <li>Puede reintentar el envío desde el listado de facturas</li>
                                </ul>
                            </Alert>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleCerrarModalEnviando}>
                        <i className="fas fa-check mr-1"></i>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default CompletarDatosFactura;
